const getItemWidth = (item) => {
  if (!item) {
    return null;
  }

  if (typeof item.width === 'function') {
    return item.width();
  }

  return item.width;
};

export default getItemWidth;
